import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const DocumentLibraryPanel = ({ documents, loading }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })?.format(date);
  };

  const getDocumentIcon = (type) => {
    const iconMap = {
      'عقد بيع': 'FileText',
      'عقد إيجار': 'FileSignature',
      'شهادة': 'Award',
      'مراسلة': 'Mail'
    };
    return iconMap?.[type] || 'File';
  };

  const getStatusColor = (status) => {
    const colors = {
      'active': 'bg-success/10 text-success border-success/20',
      'approved': 'bg-primary/10 text-primary border-primary/20',
      'pending': 'bg-warning/10 text-warning border-warning/20',
      'expired': 'bg-muted text-muted-foreground border-border'
    };
    return colors?.[status] || colors?.['pending'];
  };

  const categories = [
    { value: 'all', label: 'الكل', icon: 'Folder' },
    { value: 'contracts', label: 'العقود', icon: 'FileText' },
    { value: 'certificates', label: 'الشهادات', icon: 'Award' },
    { value: 'correspondence', label: 'المراسلات', icon: 'Mail' }
  ];

  const handleDownload = (document) => {
    // Mock download functionality
    console.log('Downloading document:', document);
    alert(`جاري تحميل: ${document?.contractNumber}`);
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-muted rounded w-1/3"></div>
          <div className="h-20 bg-muted rounded"></div>
          <div className="h-20 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden" dir="rtl">
      {/* Header */}
      <div className="p-4 border-b border-border bg-muted/30">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Icon name="FolderOpen" size={20} color="var(--color-primary)" />
            <h3 className="font-heading font-semibold text-foreground">مكتبة المستندات</h3>
          </div>
          <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold">
            {documents?.length || 0} مستند
          </span>
        </div>

        {/* Category Filter */}
        <div className="flex gap-2 overflow-x-auto pb-2">
          {categories?.map(category => (
            <button
              key={category?.value}
              onClick={() => setSelectedCategory(category?.value)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                selectedCategory === category?.value
                  ? 'bg-primary text-white' :'bg-muted/50 text-muted-foreground hover:bg-muted'
              }`}
            >
              <Icon name={category?.icon} size={16} />
              {category?.label}
            </button>
          ))}
        </div>
      </div>

      {/* Documents List */}
      <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
        {!documents || documents?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="FileX" size={40} color="var(--color-muted-foreground)" />
            <p className="text-muted-foreground mt-3">لا توجد مستندات متاحة</p>
          </div>
        ) : (
          documents?.map((doc, index) => (
            <div 
              key={index}
              className="flex items-center gap-3 p-3 rounded-lg border border-border hover:bg-muted/30 transition-colors"
            >
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={getDocumentIcon(doc?.contractType)} size={18} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="font-semibold text-foreground text-sm truncate">
                    {doc?.contractNumber}
                  </h4>
                  <span className={`px-2 py-0.5 rounded text-xs font-semibold border ${getStatusColor(doc?.status)}`}>
                    {doc?.status === 'active' ? 'نشط' : doc?.status === 'approved' ? 'معتمد' : 'معلق'}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground truncate">{doc?.propertyTitle}</p>
                <p className="text-xs text-muted-foreground mt-1">{formatDate(doc?.createdAt)}</p>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleDownload(doc)}
                  className="p-2 rounded-lg hover:bg-primary/10 transition-colors"
                  title="تحميل"
                >
                  <Icon name="Download" size={18} color="var(--color-primary)" />
                </button>
                <button
                  className="p-2 rounded-lg hover:bg-primary/10 transition-colors"
                  title="معاينة"
                >
                  <Icon name="Eye" size={18} color="var(--color-primary)" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DocumentLibraryPanel;